import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { RequisitionStatusChipComponent }
  from '../requisition-status-chip/requisition-status-chip.component';

export interface Requisition {

  id: number;

  patientId: number;

  patientName: string;

  doctorName: string;

  mobileNumber: string;

  tests: string;

  status: string;

  date: string;

  comments: string;

  photoURL?: string;

  patientObject?: any;

  services?: any;

  url?: string;
}

@Component({
  selector: 'app-requisition-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    RequisitionStatusChipComponent
  ],
  templateUrl: './requisition-table.component.html',
  styleUrls: ['./requisition-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequisitionTableComponent {

  @Input()
  loading = false;
  @Output()
  uploadReport =
    new EventEmitter<Requisition>();

  @Output()
  createRequisition = new EventEmitter<any>();

  @Input()
  requisitions: Requisition[] = [];

  @Output()
  upload =
    new EventEmitter<Requisition>();


  @Output()
  statusUpdate =
    new EventEmitter<Requisition>();

  displayedColumns = [

    'srno',

    'patient',

    'doctor',

    'date',

    'tests',

    'status',

    'comment',

    'action'
  ];


  ngonint(): void {
    setTimeout(() => {
      console.log("requisitions", this.requisitions);
    }, 5000);

  }


  updateStatus(
    row: Requisition
  ): void {

    this.statusUpdate.emit(row);

  }

  getStatusLabel(status: string): string {

    if (
      status === 'Open' ||
      status === null ||
      status === 'null'
    ) {
      return 'Open';
    }

    if (status === 'Sample collected') {
      return 'Sample Collected';
    }

    return status;
  }

  getStatusText(status: string): string {

    if (
      !status ||
      status === 'null'
    ) {
      return 'Open';
    }

    if (status === 'Sample collected') {
      return 'Sample Collected';
    }

    return status;
  }

  getStatusClass(status: string): string {

    if (
      !status ||
      status === 'null'
    ) {
      return 'open';
    }

    if (status === 'Confirmed') {
      return 'confirmed';
    }

    if (status === 'Done') {
      return 'done';
    }

    if (status === 'Sample collected') {
      return 'sample';
    }

    return 'open';

  }
}


